<template>
  <div>
    <el-timeline style="overflow-y: auto;height: calc(100vh - 100px);">
      <el-timeline-item
        icon="el-icon-circle-check"
        type="primary"
        size="large"
        placement="top"
        v-for="(item, index) in listData"
        :key="index"
        :timestamp="item.logTime"
      >
        <div class="feeback-context">
          <p class="title" v-if="item.logTitleName">{{ item.logTitleName }}</p>
          <span v-if="item.createByName">
            反馈客服：{{ item.createByName }}
          </span>
          <span v-if="item.driverName">司机：{{ item.driverName }}</span>
          <span v-if="item.logPlace">实时地点：{{ item.logPlace }}</span>
          <p v-if="item.logDesc">{{ item.logDesc }}</p>
        </div>
        <swiper
          v-viewer="{ movable: true }"
          class="swiper mt-1"
          ref="swiper"
          :options="swiperOption"
        >
          <swiper-slide v-for="(image, index) in item.imgs" :key="index">
            <el-image
              :src="$osscdn(image.imageUrl)"
              style="width:100%;height:100px;"
              fit="contain"
            />
          </swiper-slide>
        </swiper>
      </el-timeline-item>
      <el-timeline-item
        v-if="!listData || !listData.length"
        size="large"
        icon="el-icon-warning-outline"
      >
        暂无反馈信息
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
export default {
  props: {
    waybillDetailCode: { type: String, default: '' },
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      listData: [],
    }
  },
  methods: {
    loadData() {
      if (!this.waybillDetailCode) return
      this.$api
        .carrierWaybillSelectFeedbackApi({
          waybillDetailCode: this.waybillDetailCode,
        })
        .then((res) => {
          this.listData = res.body.data
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.feeback-context span {
  margin-right: 10px;
  &:last-child {
    margin-right: 0;
  }
}
p.title {
  font-size: 18px;
  line-height: 32px;
}
p {
  margin: 6px 0;
  line-height: 22px;
}
</style>
